// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LKhe","questions":"styles_questions__2Nonm","footer":"styles_footer__2LEPf"};